/**
 * @generated SignedSource<<e7189ca0884fb6a2778f8230b6eb5c66>>
 * @relayHash 741cb5df6adfcaa4c4e00bf870fcc0c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5f332c502a8d6c3f21250ad8d9e08058c42cb19c588d63f4ea5818ad100a18f9

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraIssueSearchViewLayout = "DETAIL" | "LIST" | "%future added value";
export type JiraSetIssueSearchViewLayoutInput = {
  viewId: string;
  viewLayout: JiraIssueSearchViewLayout;
};
export type useSelectedViewMutation$variables = {
  input: JiraSetIssueSearchViewLayoutInput;
};
export type useSelectedViewMutation$data = {
  readonly jira_setIssueSearchViewLayout: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useSelectedViewMutation = {
  response: useSelectedViewMutation$data;
  variables: useSelectedViewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "JiraSetIssueSearchViewLayoutPayload",
    "kind": "LinkedField",
    "name": "jira_setIssueSearchViewLayout",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useSelectedViewMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSelectedViewMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "5f332c502a8d6c3f21250ad8d9e08058c42cb19c588d63f4ea5818ad100a18f9",
    "metadata": {},
    "name": "useSelectedViewMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "65b41e477de41628cbbb17392e93350d";

export default node;
